import { useCallback } from 'react';
import { useGetUserInfoQuery } from 'app/hooks/user-info';
import { useDialogManagerContext } from 'context';

export default function useRequireUserNames() {
  const { data: user } = useGetUserInfoQuery();
  const { setUserNamesDialog } = useDialogManagerContext();

  const hasAllRequiredNames = Boolean(
    user?.first_name?.trim() && user?.last_name?.trim(),
  );

  const requireUserNames = useCallback(() => {
    if (!hasAllRequiredNames) {
      setUserNamesDialog.open();
      return false;
    }

    return true;
  }, [hasAllRequiredNames, setUserNamesDialog]);

  return {
    hasAllRequiredNames,
    requireUserNames,
  };
}
